import { StakingContract } from '@trustpad/launchpad';
import { StakingContractV2 } from '@trustpad/launchpad/dist/staking/hooks/useStakingContract';
import { StakingState } from '@trustpad/launchpad/dist/staking/hooks/useStakingV2';
import { Token } from '@trustpad/launchpad/dist/types';

import React, { useEffect } from 'react';
import { Col, Form, InputGroup } from 'react-bootstrap';

import { AddressWithLink } from '~features/pools/components/PoolSecondaryBlock/AddressWithLink';
import { useStakingAdmin } from '~features/staking/StakingAdminForm/useStakingAdmin';
import { ActionButton } from '~features/ui';
import { fNum } from '~utils';

export function StakingAdminForm({
  contract,
  apr,
  state,
  rewardToken,
  onAprChange,
  refresh,
}: {
  contract: StakingContractV2 | StakingContract;
  apr: number;
  state: StakingState;
  rewardToken: Token;
  onAprChange: (v: number) => void;
  refresh?: VoidFunction;
}) {
  const {
    reward,
    saveReward,
    setReward,
    rewardPerDay,
    treasury,
    newApr,
    isLoading,
  } = useStakingAdmin({
    contract,
    apr,
    state,
    rewardDecimals: rewardToken.decimals,
    refresh,
  });

  useEffect(() => {
    onAprChange(newApr);
  }, [newApr, onAprChange]);

  return (
    <div className="space-y-2 bg-gray-800/40 mt-6 p-3 rounded text-sm">
      <AddressWithLink
        address={treasury}
        label="Treasury (to deposit reward tokens):"
        chain="BSC"
      />

      <Form.Row className="items-center">
        <Col xs="auto">
          <Form.Group controlId="reward">
            <Form.Label>Reward per block</Form.Label>

            <InputGroup className="mb-2">
              <Form.Control
                placeholder="Reward per block"
                value={reward}
                onChange={(e) => setReward(e.target.value)}
              />
            </InputGroup>

            <Form.Text className="text-muted">
              Per day (28.8k blocks): <br />
              {fNum(rewardPerDay)} {rewardToken.symbol} / $
              {fNum(rewardPerDay * rewardToken.price.usd)}.
            </Form.Text>
          </Form.Group>
        </Col>
        <Col xs="auto">
          <ActionButton isLoading={isLoading} onClick={saveReward}>
            Update
          </ActionButton>
        </Col>
      </Form.Row>
    </div>
  );
}
